import styled from '@emotion/styled'
import { Text, withCitrusTheme } from '@gousto-internal/citrus-react'

export const UnorderedList = styled.ul({
  display: 'flex',
  listStyle: 'none',
  margin: '0',
  padding: '0',
})

export const ListItem = styled.li({
  display: 'flex',
  alignItems: 'center',
})

export const FutureLink = withCitrusTheme(Text, () => ({
  cursor: 'default',
  pointerEvents: 'none',
}))
